"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _HBRadioButton = _interopRequireDefault(require("../HBRadioButton/HBRadioButton"));
var _HBField = _interopRequireDefault(require("../HBField/HBField"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBRadioButtonGroup = function HBRadioButtonGroup(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange,
    name = _ref.name,
    _ref$labelPlacement = _ref.labelPlacement,
    labelPlacement = _ref$labelPlacement === void 0 ? 'right' : _ref$labelPlacement,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 8 : _ref$gap,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'vertical' : _ref$alignment,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    customTheme = _ref.customTheme;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'radio-button-group',
    componentName: 'HBRadioButtonGroup',
    enforce: false
  });
  return (
    /*#__PURE__*/
    // Todo: how should the container behave for different sizes? (and custom theme)
    _react["default"].createElement(Container, {
      gap: gap,
      alignment: alignment,
      "data-testid": finalTestId
    }, options.map(function (_ref2) {
      var label = _ref2.label,
        optValue = _ref2.value,
        disabled = _ref2.disabled;
      return /*#__PURE__*/_react["default"].createElement(_HBField["default"], {
        key: optValue,
        id: optValue.toString(),
        label: label,
        placement: labelPlacement,
        testIdName: "".concat(testIdName, "-").concat(optValue),
        size: size
      }, /*#__PURE__*/_react["default"].createElement(_HBRadioButton["default"], {
        id: optValue.toString(),
        name: name,
        checked: optValue === value,
        onChange: onChange,
        value: optValue,
        size: size,
        customTheme: customTheme,
        disabled: disabled
      }));
    }))
  );
};
var _default = exports["default"] = HBRadioButtonGroup;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBRadioButtonGroup__Container",
  componentId: "sc-1w2lhge-0"
})(["display:flex;flex-direction:", ";gap:", "px;"], function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === 'horizontal' ? 'row' : 'column';
}, function (_ref4) {
  var gap = _ref4.gap;
  return gap;
});
//# sourceMappingURL=HBRadioButtonGroup.js.map